import React, { PureComponent, Fragment } from 'react';
import Helmet from 'react-helmet';
import { withTranslation } from 'react-i18next';
import NewsletterSignUp from '../../../../common/components/forms/NewsletterSignUp.js';

import { Grid, Cell } from 'formlabs-web-components/Grid';
import { Header, Eyebrow } from 'formlabs-web-components/Type';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import Card from '../../../../common/components/content/Card';
import BlogPagination from './BlogPagination';
import './Blog.module.css';
const BlogPostList = DisplayComponent(
  class BlogPostList extends PureComponent {
    render() {
      const {
        posts,
        page,
        children,
        classes,
        hasNext,
        hasPrev,
        path,
        t
      } = this.props;
      return (
        <Grid direction="x">
          {page > 1 ? (
            <Helmet>
              <link rel="canonical" href={`${path}?page=${page}`} />
            </Helmet>
          ) : null}
          <Cell largeSize={24}>
            <div styleName="filter-posts" className={classes} />
          </Cell>
          <Cell largeSize={children ? 16 : 24}>
            <div styleName="posts">
              {posts.map(post => {
                return (
                  <div
                    key={`${post.title}${post.slug}`}
                    styleName="post-wrapper"
                  >
                    <div styleName="post-sizing">
                      <Card
                        url={post.url}
                        imageConstraint="30%"
                        imagePosition="left"
                        bgColor="transparent-black"
                        image={post.smallListingImage}
                        padding="35px 0"
                        hover="light-grey"
                      >
                        <div styleName="post-eyebrows">
                          <Eyebrow color="blue">{post.type}</Eyebrow>
                          <Eyebrow color="medium-grey">{post.pub_date}</Eyebrow>
                        </div>
                        <Header level={4} displayAs={4} weight={400}>
                          {post.title}
                        </Header>
                      </Card>
                    </div>
                  </div>
                );
              })}
            </div>
            <BlogPagination page={page} hasNext={hasNext} hasPrev={hasPrev} />
          </Cell>
          {children && (
            <Cell largeSize={8} backgroundColor="light-grey">
              <div styleName="sidebar">
                <Fragment>
                  <NewsletterSignUp layoutType="sidebar" />
                </Fragment>
                <Fragment>{children}</Fragment>
              </div>
            </Cell>
          )}
        </Grid>
      );
    }
  }
);

BlogPostList.propTypes = {};

export default withTranslation()(BlogPostList);
